/**
 * @file
 * Lazy load images.
 */

$('img.image-lazy-load', context)
  .once('cpl-image-lazy-load')
  .each(function() {
    window.lazyload($(this).toArray());
  });
